import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { ShieldCheck, Lock, CreditCard, Star, XCircle } from 'lucide-react';
export const Hero = () => {
  return <section className="bg-bg-base px-4 pt-4 pb-7 md:pt-16 md:pb-16 overflow-hidden" data-id="element-287" data-mp="mz5y1ndih8kh">
      <div className="max-w-[700px] mx-auto text-center space-y-2.5 md:space-y-6" data-id="element-288" data-mp="rubp10lrtdff">
        <FadeIn data-id="element-289" data-mp="wqjzw1sxqkgs">
          <div className="space-y-2 md:space-y-4" data-id="element-290" data-mp="wt67u2jqn1zj">
            <div className="inline-flex items-center gap-1.5 bg-bg-card text-brandOrange font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full border border-brandOrange/30" data-id="element-291" data-mp="3va0nvm3gjo4o">
              <span className="text-sm md:text-base" data-id="element-292" data-mp="93u1dafsp80x">🏋️</span>
              <span className="text-[8.5px]" data-id="element-293" data-mp="e1vhbmhxcr86">MEGAPACK FUNCIONAL 365™</span>
            </div>
            <h1 className="font-hero font-normal uppercase text-[32px] md:text-[72px] leading-[1.0] tracking-[0.5px] text-txt-primary px-2 pt-3 pb-1" data-id="element-294" data-mp="1khpiupu69svb">
              TODAS TUS CLASES DE{' '}
              <span className="text-brandOrange" data-id="element-295" data-mp="1hakcpgucfem6">FUNCIONAL</span>
              <br data-id="element-296" data-mp="1h7y55h7gcz3y" />
              <span data-id="element-297" data-mp="1cbh81xi9zaeq">LISTAS. DESDE HOY.</span>
            </h1>
            <p className="text-txt-body text-[12.5px] md:text-[16px] leading-[1.4] md:leading-[1.7] font-sans px-3" data-id="element-298" data-mp="1cc0rxjrhk8ve">
              365 sesiones · Warm-ups · Circuitos · Clases listas · WODs
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-299" data-mp="yb6h6ugytvtk">
          <a href="#pricing" className="block cursor-pointer relative" data-id="element-300" data-mp="yc82drrp3yp0">
            <div className="absolute inset-0 bg-brandOrange/15 blur-[40px] rounded-full" data-id="element-301" data-mp="tk7u9c1h1zhc"></div>
            <div className="absolute inset-y-0 -inset-x-10 bg-brandBlue-electric/10 blur-[28px] rounded-full" data-id="element-302" data-mp="ol51or2ohlq9"></div>
            <img src="https://cdn.magicpatterns.com/uploads/gQtkVod4u9DhJDMUTT1MKv/mockup_sticker.png" alt="MEGAPACK Funcional 365 — Mockup completo del producto" loading="eager" decoding="async"
          // @ts-ignore
          fetchpriority="high" className="relative block w-full max-w-[260px] md:max-w-[520px] mx-auto h-auto object-contain hover:-translate-y-1 transition-transform duration-300 drop-shadow-2xl" data-id="element-303" data-mp="kkumcnszxiyq" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-304" data-mp="3n7apspwq3f9y">
          <div className="max-w-2xl mx-auto space-y-2.5 md:space-y-5" data-id="element-305" data-mp="3s4klgnapgn68">
            {/* Chips - same on all screens */}
            <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center items-center" data-id="element-306" data-mp="johgipaz9cll">
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-307" data-mp="oodm2szbpc39">
                <span className="text-[10px] md:text-xs" data-id="element-308" data-mp="exj1dt1q6kjx">📄</span> 100% PDF
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-309" data-mp="12n3gu1yo6zog">
                <span className="text-[10px] md:text-xs" data-id="element-310" data-mp="2s3z25ziz9jh8">⚡</span> Acceso en 5
                min
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-311" data-mp="2n4mdd98jq2c0">
                <span className="text-[10px] md:text-xs" data-id="element-312" data-mp="2wws5ciyssjr7">📚</span> 365 sesiones
              </span>
            </div>

            {/* CTA button + trust */}
            <div className="space-y-2 md:space-y-3" data-id="element-313" data-mp="2471q26lfjbti">
              <CTAButton href="#pricing" fullWidth className="!py-3.5 md:!py-4 !text-[15px] md:!text-base" data-id="element-314" data-mp="248cum8mp8nlo">
                💪 QUIERO EL MEGAPACK AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-[9.5px] md:text-xs text-txt-muted font-sans" data-id="element-315" data-mp="3tlq56flen7v8">
                <span className="flex items-center gap-1" data-id="element-316" data-mp="3pjcxhln3kzvt">
                  <ShieldCheck size={11} className="text-success" data-id="element-317" data-mp="op6sr1uzxhrq" /> Garantía 7
                  días
                </span>
                <span className="flex items-center gap-1" data-id="element-318" data-mp="spqruaz4qvgi">
                  <Lock size={11} className="text-txt-muted" data-id="element-319" data-mp="ssbswxrlt7d7" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-320" data-mp="xry6577fmnm0">
                  <CreditCard size={11} className="text-brandBlue-electric" data-id="element-321" data-mp="12phke744r0dy" />{' '}
                  Pagas en tu moneda local
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  return <div className="bg-bg-alt border-y border-line py-6" data-id="element-322" data-mp="1gh4lck90ox32">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-323" data-mp="1lf69vkp7polx">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-line" data-id="element-324" data-mp="1leo8k9np0k75">
          <FadeIn delay={0.1} data-id="element-325" data-mp="1qfu2gat3adi9">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-326" data-mp="1qcg032kfe4at">
              +500
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-327" data-mp="3fw634jwd3utb">
              coaches confían
            </div>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-328" data-mp="3ayebzs3jkcq6">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-329" data-mp="35wyprwpmo067">
              6
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-330" data-mp="30zotbx3tmo8v">Tomos listos</div>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-331" data-mp="2fyphi1ywtt0">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-332" data-mp="2ickjqwne60k">
              5
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-333" data-mp="3ourt3045yc44">
              Bonos incluidos
            </div>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-334" data-mp="3jux3czw4jskn">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-335" data-mp="l6puy8iu4024">
              4.9/5
            </div>
            <div className="text-sm font-sans text-txt-body flex items-center justify-center gap-1" data-id="element-336" data-mp="geyc6k5x6ymj">
              calificación <Star size={12} className="fill-gold text-gold" data-id="element-337" data-mp="2aq7tal8sxrki" />
            </div>
          </FadeIn>
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'MR',
    text: 'Me ahorró muchísimo tiempo. Llegué al lunes con todo listo y sin dar vueltas. Muy recomendable.',
    author: 'Marcos R.',
    role: 'Coach de Funcional · México',
    bg: 'bg-brandOrange'
  }, {
    initials: 'CP',
    text: 'Tenía mis dudas antes de comprarlo, pero me sorprendió. Con las tres versiones manejo grupos mixtos sin problema.',
    author: 'Carolina P.',
    role: 'Instructora · Colombia',
    bg: 'bg-brandBlue-electric'
  }, {
    initials: 'DG',
    text: 'Armo la clase en 10 minutos y se nota. Por lo que cuesta, lo recomiendo sin dudar.',
    author: 'Diego G.',
    role: 'Profe de Box · Perú',
    bg: 'bg-brandOrange'
  }];
  return <Section className="bg-bg-base" data-id="element-338" data-mp="15of3s2ukxwqy">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4" data-id="element-339" data-mp="15phpzxgyjb0j">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-340" data-mp="10oaj00mn2fux" data-mpi={i}>
            <div className="bg-bg-card p-3.5 md:p-5 rounded-[14px] md:rounded-[18px] border border-line h-full flex flex-col" data-id="element-341" data-mp="1fft7ynxh7kqf">
              <div className="flex items-center gap-2.5 mb-2.5" data-id="element-342" data-mp="1am862ksri6ly">
                <div className={`w-8 h-8 md:w-9 md:h-9 ${t.bg} text-white rounded-full flex items-center justify-center font-sans font-bold text-[11px] md:text-xs shrink-0`} data-id="element-343" data-mp="1oeofq4g652vu">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-344" data-mp="1tf2awlwo8icg">
                  <div className="flex text-gold mb-0.5" data-id="element-345" data-mp="1tg3xnnn1uta0">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-346" data-mp="40e8ndhsogs5" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[12px] md:text-[13px] leading-tight" data-id="element-347" data-mp="3v88pz08gnsl9">
                    {t.author}
                  </p>
                  <p className="text-[10px] md:text-[11px] font-sans text-txt-muted" data-id="element-348" data-mp="3eas2elajr3ef">
                    {t.role}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[12.5px] md:text-[13.5px] leading-[1.5] italic" data-id="element-349" data-mp="3o25wuenn5d0p">
                "{t.text}"
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['Llegas al gimnasio sin saber exactamente qué clase dar hoy', 'Pasas horas del domingo buscando ejercicios que se adapten a tu grupo', 'Repites los mismos circuitos porque no tienes un banco de sesiones armado', 'El alumno nuevo llega y no sabes cómo adaptarle la clase en el momento', 'Quieres un programa anual estructurado pero no tienes tiempo de armarlo', 'Sientes que tu grupo se estanca cuando quieres darle progresión real', 'Fin de semana en la noche y vuelves a empezar el mismo ciclo'];
  return <Section className="bg-bg-alt" data-id="element-350" data-mp="205evh4cbdrc5">
      <div className="max-w-[720px] mx-auto" data-id="element-351" data-mp="206hkf6q2tjpf">
        <FadeIn data-id="element-352" data-mp="1vclt2n4biv38">
          <h2 className="font-display font-extrabold uppercase md:text-[44px] text-center mb-8 text-txt-primary text-[26px]" data-id="element-353" data-mp="1vc3v9m20c8t7">
            Si eres profe de <span className="text-brandOrange" data-id="element-354" data-mp="1lf7l7bwgnemj">funcional,</span>
            <br data-id="element-355" data-mp="1lgsfr1iryxke" />
            esto te va a sonar familiar...
          </h2>

          <div className="space-y-2 md:space-y-3 mb-10" data-id="element-356" data-mp="1gf31ze4645sm">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2.5 bg-bg-card border border-line rounded-[10px] py-2.5 px-3 md:py-3 md:px-4" data-id="element-357" data-mp="1cfklqvnakiw4" data-mpi={i}>
                <XCircle className="text-danger shrink-0 mt-0.5" size={16} data-id="element-358" data-mp="36stx6szeeeh0" />
                <p className="text-txt-body font-sans text-[13px] md:text-[15px] leading-[1.5]" data-id="element-359" data-mp="31tqrd6blg47z">
                  {point}
                </p>
              </div>)}
          </div>

          {/* Neon divider */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mb-10 md:mb-12" style={{
          background: 'linear-gradient(90deg, transparent 0%, #FF6B00 50%, transparent 100%)',
          boxShadow: '0 0 12px rgba(255,107,0,0.8), 0 0 24px rgba(255,107,0,0.5)'
        }} data-id="element-360" data-mp="ddd4ao63f9lz"></div>

          <h3 className="font-display font-extrabold uppercase md:text-[52px] text-center text-txt-primary mb-8 relative text-[30px]" data-id="element-361" data-mp="3qrggrftz3ppp">
            ¿Sigues improvisando tus{' '}
            <span className="text-brandOrange inline-block" style={{
            textShadow: '0 0 20px rgba(255,107,0,0.6), 0 0 40px rgba(255,107,0,0.4)'
          }} data-id="element-362" data-mp="8fjxbswyubkn">
              entrenamientos?
            </span>
          </h3>

          <div className="space-y-4 text-txt-body font-sans text-[15px] md:text-base leading-[1.7] mb-10" data-id="element-363" data-mp="371ee1fep4fcx">
            <p data-id="element-364" data-mp="1mjlo0akkgnex">
              Elegiste esta profesión porque amas el entrenamiento funcional y
              ver crecer a tu grupo.
            </p>
            <p data-id="element-365" data-mp="1dlt751z757pf">
              Pero nadie te dijo que ibas a perder tiempo buscando circuitos que
              no encajan con tu grupo, armando sesiones a último momento y
              llegando el lunes improvisando algo que "más o menos sirve".
            </p>
          </div>

          {/* Highlighted closing question */}
          <div className="relative bg-bg-card border-2 border-brandOrange rounded-[16px] py-5 px-5 md:py-6 md:px-8 shadow-[0_0_40px_rgba(255,107,0,0.25)]" data-id="element-366" data-mp="2aa7wg2yhg9pg">
            <p className="font-display font-extrabold text-[20px] md:text-[28px] leading-[1.2] text-center text-txt-primary" data-id="element-367" data-mp="219jif893a9ck">
              ¿Y SI ESTA FUERA LA{' '}
              <span className="text-brandOrange" data-id="element-368" data-mp="kyfidr5njige">ÚLTIMA CLASE</span>
              <br data-id="element-369" data-mp="pwqsm2zuzuz5" />
              QUE PREPARAS ASÍ?
            </p>
          </div>

          {/* Neon divider — transition to product */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mt-10 md:mt-14" style={{
          background: 'linear-gradient(90deg, transparent 0%, #FF6B00 50%, transparent 100%)',
          boxShadow: '0 0 12px rgba(255,107,0,0.8), 0 0 24px rgba(255,107,0,0.5)'
        }} data-id="element-370" data-mp="1rg2elfru2u1"></div>
        </FadeIn>
      </div>
    </Section>;
};